Object.defineProperty(exports, '__esModule', {
  value: true
});
(function (Brand) {
  Brand["Bsm"] = "BSM";
  Brand["Aad"] = "AAD";
})(exports.Brand || (exports.Brand = {}));
(function (CalendarView) {
  CalendarView["day"] = "DAY";
  CalendarView["threeDay"] = "THREE_DAY";
  CalendarView["week"] = "WEEK";
  CalendarView["month"] = "MONTH";
})(exports.CalendarView || (exports.CalendarView = {}));
(function (EventType) {
  EventType["Unavailable"] = "UNAVAILABLE";
  EventType["PaidLesson"] = "PAID_LESSON";
  EventType["UnpaidLesson"] = "UNPAID_LESSON";
  EventType["NewLesson"] = "NEW_LESSON";
  EventType["Travel"] = "TRAVEL";
  EventType["Cancelled"] = "CANCELLED";
})(exports.EventType || (exports.EventType = {}));
(function (EventRepeat) {
  EventRepeat["Daily"] = "Daily";
  EventRepeat["Weekly"] = "Weekly";
  EventRepeat["Fortnightly"] = "Fortnightly";
  EventRepeat["Monthly"] = "Monthly";
})(exports.EventRepeat || (exports.EventRepeat = {}));
(function (LessonStatus) {
  LessonStatus["Active"] = "Active";
  LessonStatus["Pending"] = "Pending";
  LessonStatus["Cancelled"] = "Cancelled";
  LessonStatus["Deleted"] = "Deleted";
})(exports.LessonStatus || (exports.LessonStatus = {}));